import * as React from 'react';
import styles from "./styles.module.css";
import { Checkbox, Typography } from '@mui/material';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import AddButton from '../../../components/AddButton/AddButton';
import OrganizationFilterSelect from '../../../components/OrganizationFilterSelect/OrganizationFilterSelect';
import CustomerFilterSelect from '../../../components/CustomerFilterSelect/CustomerFilterSelect';
import SLAFilterSelect from '../../../components/SLAFilterSelect/SLAFilterSelect';
import SystemFilterSelect from '../../../components/SystemFilterSelect/SystemFilterSelect';
import ServiceTypeFilterSelect from '../../../components/ServiceTypeFilterSelect/ServiceTypeFilterSelect';
import MaintenanceTicketStatusFilterSelect from '../../../components/MaintenanceTicketStatusFilterSelect/MaintenanceTicketStatusFilterSelect';
import TableSearchInput from '../../../components/TableSearchInput/TableSearchInput';
import { AssetAddSLADialog } from '../AssetAddSLADialog';
import MaintenanceListTable from './MaintenanceListTable';

export interface Props {
}

const MaintenanceList: React.FunctionComponent<Props> = () => {

    const { t } = useLanguageLocale();

    const [orgnizationId, setOrgnizationId] = React.useState<string | undefined>();
    const [customerId, setCustomerId] = React.useState<string>('');
    const [systemId, setSystemId] = React.useState<string>('');
    const [serviceType, setServiceType] = React.useState<number | undefined>();
    const [ticketStatus, setTicketStatus] = React.useState<number | undefined>();
    const [searchText, setSearchText] = React.useState<string | undefined>();
    const [isFavorite, setIsFavorite] = React.useState<boolean | undefined>();
    const [currentPage, setCurrentPage] = React.useState<number>(0);
    const [openAddSLADialog, setOpenAddSLADialog] = React.useState<boolean>(false);

    const handleOrgnizationChange = (e: string) => {
        setOrgnizationId(e);
        setCustomerId('');
        setSystemId('');
    }

    const handleCustomerChange = (e: string) => {
        setCustomerId(e);
        setSystemId('');
    }

    const handleSystemChange = (e: string) => {
        setSystemId(e);
    }

    const handleServiceTypeChange = (e: number) => {
        setServiceType(e);
    }

    const handleTicketStatusChange = (e: number) => {
        setTicketStatus(e);
    }

    const handleSearchTextChange = (value: string) => {
        if (value.length > 2) {
            setSearchText(value);
        } else {
            setSearchText(undefined);
        }
    }

    const handleFavoriteCheckboxChange = (e: any) => {
        setIsFavorite(e.target.checked);
    }

    React.useEffect(() => {
        setCurrentPage(0);
    }, [orgnizationId, customerId, systemId, serviceType, ticketStatus, searchText, isFavorite])

    return (
        <>
            <div id="asset-maintenance-ticket-container" data-testid="asset-maintenance-ticket-container">
                <div className={styles.header1}>
                    <AddButton testId={'sla-add-button'} text={t('ASSETS_DETAILS.ADD_SLA')} callback={() => { setOpenAddSLADialog(true) }} />
                    <div className={styles.block1} style={{ display: 'none' }}>
                        <Typography
                            id="maintenance-ticket-favorite-filter-checkbox-lable"
                            data-testid="maintenance-ticket-favorite-filter-checkbox-lable"
                            style={{ alignSelf: 'center' }} variant="body2">
                            {t('ASSETS_DETAILS.SHOW_FAVORITE_SYSTEMS')}
                        </Typography>
                        <Checkbox id="maintenance-ticket-favorite-filter-checkbox" onChange={handleFavoriteCheckboxChange}
                        />
                    </div>
                </div>
                <div className={styles.filterBlock}>
                    <OrganizationFilterSelect callback={handleOrgnizationChange} defaultValue={''} />
                    <CustomerFilterSelect callback={handleCustomerChange} defaultValue={customerId} organizationId={orgnizationId} />
                    <SLAFilterSelect callback={() => { }} defaultValue={''} disabled={true} />
                    <SystemFilterSelect callback={handleSystemChange} defaultValue={systemId} />
                    <ServiceTypeFilterSelect callback={handleServiceTypeChange} defaultValue={''} />
                    <MaintenanceTicketStatusFilterSelect callback={handleTicketStatusChange} defaultValue={''} />
                    <div style={{ marginRight: '1%', display: 'inline' }}>
                        <TableSearchInput testId={'search'} value={''} callback={handleSearchTextChange} />
                    </div>
                </div>
                <div className={styles.tableContainer}>
                    <MaintenanceListTable organizationId={orgnizationId} customerId={customerId} systemId={systemId} serviceType={serviceType} ticketStatus={ticketStatus} searchText={searchText} isFavorite={isFavorite} currentPage={currentPage} setCurrentPage={setCurrentPage} />
                </div>
            </div>
            {openAddSLADialog &&
                <AssetAddSLADialog openDialogFlag={openAddSLADialog} closeClick={() => setOpenAddSLADialog(false)} ></AssetAddSLADialog>
            }
        </>
    );
};

export default MaintenanceList;
